<script lang="ts" setup>
import { Search } from "lucide-vue-next";
import {
  ComboboxInput,
  type ComboboxInputProps,
  useForwardProps
} from "radix-vue";
import { type HTMLAttributes, computed } from "vue";
import { cn } from "../../utils";

defineOptions({
  inheritAttrs: false
});

const props = defineProps<
  ComboboxInputProps & {
    class?: HTMLAttributes["class"];
    autoFocus?: boolean;
  }
>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <div class="flex w-full items-center px-3" cmdk-input-wrapper>
    <slot name="prepend">
      <Search class="text-muted mr-2 h-4 w-4 shrink-0 opacity-50" />
    </slot>
    <ComboboxInput
      v-bind="{ ...forwardedProps, ...$attrs }"
      :auto-focus="props.autoFocus"
      :class="
        cn(
          'placeholder:text-muted-foreground flex h-11 w-full rounded bg-transparent py-3 text-sm outline-none disabled:cursor-not-allowed disabled:opacity-50',
          props.class,
          'text-base'
        )
      "
    />
  </div>
</template>
